import { create } from "zustand";

// Unsaved icon color picked in the setup form, so the page background recolors
// immediately instead of waiting for the debounced save round-trip.
type TProjectThemeStore = {
  previewIconColor: string | null;
  setPreviewIconColor: (color: string | null) => void;
};

export const useProjectThemeStore = create<TProjectThemeStore>((set) => ({
  previewIconColor: null,
  setPreviewIconColor: (previewIconColor) => set({ previewIconColor })
}));
